import type React from 'react';

import { Card, CardBody, CardHeader, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { IconTile } from '#src/app/pages/about/shared/components';

import type { ServiceType } from '../../consts';

export const ServiceCard: React.FC<ServiceType> = ({ Icon, title, body }) => {
	return (
		<Card className="bg-background-base content-start rounded-2xl">
			<CardHeader>
				<IconTile Icon={Icon} size="large" data-qa="press-service-icon-tile" />
			</CardHeader>
			<CardBody className="flex flex-col gap-2">
				<Text as="h3" variant="heading" size="x-small">
					<TypedTranslate value={title} />
				</Text>
				<Text as="p" size="small" className="text-typography-weak">
					<TypedTranslate value={body} />
				</Text>
			</CardBody>
		</Card>
	);
};
